import { StyledColorSquare } from 'views/root/views/home/views/projects/Forecasting/ProjectProgression/ProgressionTable/Header/filters/StatePicker/StatePicker.style';
import { StyledTooltipItem, StyledValuesBarTooltip } from './ValuesBar.style';

const ValueBarTooltip = ({ data, withPercents }) => {
  return (
    <StyledValuesBarTooltip>
      {data.map(item => {
        const { color, name, value, percentage } = item;
        const percentageStr = withPercents ? ` (${percentage}%)` : '';
        return (
          <StyledTooltipItem key={name}>
            <StyledColorSquare color={color} />
            {name}: {value}
            {percentageStr}
          </StyledTooltipItem>
        );
      })}
    </StyledValuesBarTooltip>
  );
};

export default ValueBarTooltip;
